import CcmConsoleNavigationHeader from 'components/organisms/ccm-console/navigation-header';
import NewlyEnrolledTable from 'components/organisms/ccm-console/newly-enrolled-table';
import PartialsTable from 'components/organisms/ccm-console/partials-table';
import FollowUpTable from 'components/organisms/ccm-console/follow-up-table';
import WorkingQueue from 'components/organisms/ccm-console/working-queue';
import { type FC } from 'react';
import NotesDrawer from 'components/organisms/ccm-console/notes-drawer';
import { useTranslation } from 'react-i18next';
import ScrollToTopButton from 'components/atoms/scroll-to-top-button';

import s from './styles.module.scss';

interface CCMConsolePageProps {}

const CCMConsolePage: FC<CCMConsolePageProps> = () => {
  const { t } = useTranslation();

  return (
    <div className={s.wrapper}>
      <WorkingQueue />
      <CcmConsoleNavigationHeader title={t('links.ccmDashboard')} />
      <NewlyEnrolledTable />
      <PartialsTable />
      <FollowUpTable />
      <NotesDrawer />
      <ScrollToTopButton />
    </div>
  );
};

export default CCMConsolePage;
